// extracted by mini-css-extract-plugin
export default {"logotype":"OlvP0","main":"WUxcB","mainImg":"vXzlJ","mainKaz":"B2Rcu","mainRus":"lwRnb","mainUzb":"l10Mj","mainBlr":"szUmq"};